import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { useTranslation } from 'react-i18next';
import '../../styles/navigationControls.css';

const NavigationControls = () => {
  const { t } = useTranslation();

  const scrollToTop = useCallback(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
  }, []);

  return (
    <button
      type="button"
      className="nav-up"
      onClick={scrollToTop}
      aria-label={t('nav.backToTop')}
      title={t('nav.up')}
    >
      <FontAwesomeIcon icon={faArrowUp} />
      <span>{t('nav.up')}</span>
    </button>
  );
};

export default NavigationControls;
